export const CLEANUP_PLACEMENT_STATE = '@spa-nonrev/air-booking/CLEANUP_PLACEMENT_STATE';
export const RETRIEVE_PLACEMENTS_FAILURE = '@spa-nonrev/air-booking/RETRIEVE_PLACEMENTS_FAILURE';
export const RETRIEVE_PLACEMENTS_SUCCESS = '@spa-nonrev/air-booking/RETRIEVE_PLACEMENTS_SUCCESS';
